import { fetchGroupsPrograms } from 'actions/Program/Group';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';

const fetchPrograms = (groupId, query = null, state) => async (dispatch) => {
  const { data: { data } } = await dispatch(fetchGroupsPrograms(groupId, { active: true, query }));

  return getProgramsOptions(data, state);
};

export default fetchPrograms;
